import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../api/baseApi";
import { AuthContext } from "../../state/AuthContext";
import { ClientContext } from "../../state/ClientContext";

export default function CaregiverAssignments() {
  const navigate = useNavigate();
  const { selectedCaregiver, changeSelectedClient, changeSelectedCaregiver } =
    useContext(ClientContext);

  const { currentUser } = useContext(AuthContext);

  const [clients, setClients] = useState([]);

  useEffect(() => {
    if (!selectedCaregiver) {
      return;
    }

    const fetchClients = async () => {
      try {
        const response = await apiRequest(
          `/caregivers/${selectedCaregiver.id}/clients`,
          { method: "GET", version: "v1" }
        );
        if (response.ok) {
          const data = await response.json();
          setClients(data);
        } else {
          console.error("Failed to fetch clients");
        }
      } catch (err) {
        console.error("Error fetching clients", err);
      }
    };

    fetchClients();
  }, [selectedCaregiver]);

  if (!selectedCaregiver) {
    return null;
  }

  return (
    <div
      className="client-profile-section"
      style={{
        backgroundColor: "#D9D9D9",
        padding: "16px",
        marginBottom: "40px",
      }}
    >
      <h1 style={{ textAlign: "left", fontWeight: "800" }}>
        Caregivers clients
      </h1>

      {(currentUser?.isSuperAdmin || currentUser?.isAdmin) && (
        <p>
          {clients.length === 0 ? (
            <span>
              This caregiver isnt assigned to any clients. Need to change that?
            </span>
          ) : (
            <span>Need to change the clients assigned to this caregiver?</span>
          )}
          <a
            href="#"
            onClick={(ev) => {
              ev.preventDefault();
              navigate("/assignment_center");
            }}
            style={{ marginLeft: "6px" }}
          >
            Go to assignment center
          </a>
        </p>
      )}

      {clients.length > 0 && (
        <table>
          <tbody>
            {clients.map((c) => (
              <tr key={c.id}>
                <td>{c.name}</td>
                <td>
                  <a
                    href="#"
                    onClick={(ev) => {
                      ev.preventDefault();
                      changeSelectedClient(null);
                      changeSelectedCaregiver(c.id);
                      navigate(`/client_profile/${c.id}`, {
                        state: { user: c },
                      });
                    }}
                  >
                    Go to client
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
